import React, { useCallback, useMemo } from 'react';

// DEPENDENCIES
import { useNavigate, useLocation } from 'react-router';

// GLOBAL FUNCTIONS
import { makePath } from 'functions';

// GLOBAL VARIABLES
import { RECORD } from 'pathnames.js';

// GLOBAL COMPONENTS
import Dropdown from 'core/tools/dropdown/Dropdown';
import Item from 'routers/interface/tools/Item';

const OrderSelect = ({ saleTypeCatgories }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const options = useMemo(() => {
    return saleTypeCatgories.map(c => ({ label: c.sale_type_category, value: [+c.sale_type_category_id] }));
  }, [saleTypeCatgories]);

  const handleOnSelect = useCallback(
    option => {
      const params = new URLSearchParams();
      params.append('saleTypeCategoryId', option);

      navigate(`${makePath(pathname, RECORD.view)}?${params.toString()}`);
    },
    [pathname, navigate]
  );

  return (
    <Dropdown
      toggle={{
        label: 'Specify Sort Order',
        size: 'sm',
        outline: true,
        disabled: !options.length
      }}
    >
      {options.map(({ label, value }) => (
        <Item option={label} key={value} onSelect={() => handleOnSelect(value)} />
      ))}
    </Dropdown>
  );
};

export default OrderSelect;
